export default "__VITE_ASSET__Z7lCn3iM__"